import React from 'react';
import { merge, keyBy, values } from 'lodash';
import { formatMoney, isMobile } from 'common/helpers';
import { Icon } from 'antd';
import { Hotel as S } from './styles';

export function arrayMergeByKey(array1, array2, key) {
  const merged = merge(keyBy(array1, key), keyBy(array2, key));
  return values(merged);
}

export function getTextRating(rating) {
  return rating > 8.8 ? 'Excellent!' : 'Very Good!';
}

export function getPercentage(origPrice = 0, price = 0) {
  return price > 0
    ? Math.round(formatMoney((origPrice - price) / origPrice, 2) * 100)
    : 'X';
}

export function renderStars(stars) {
  const content = [];
  for (let x = 1; x <= 5; x += 1) {
    content.push(
      x <= stars ? (
        <Icon type="star" theme="filled" key={x} />
      ) : (
        <Icon type="star" key={x} />
      )
    );
  }
  return <S.Stars>{content}</S.Stars>;
}

export function renderPerfectFor(items) {
  return (
    <S.PerfectFor className="perfectfor">
      {!isMobile() ? <p>Perfect for:</p> : null}
      <ul>
        {items.map((item) => (
          <li key={item.toString()}>{item}</li>
        ))}
      </ul>
    </S.PerfectFor>
  );
}

export function formatXMoney(price, xcount = 'XX') {
  return price > 0 ? formatMoney(price, 0) : xcount;
}



// WEBPACK FOOTER //
// ./src/containers/Hotel/helpers.js